import { createAsyncStoragePersister } from '@tanstack/query-async-storage-persister'
import {
  persistQueryClientRestore,
  persistQueryClientSubscribe
} from '@tanstack/query-persist-client-core'
import { QueryClient } from '@tanstack/react-query'
import { removeOldestQuery } from '@tanstack/react-query-persist-client'

const PERSISTED_DASHBOARD_QUERY_KINDS = new Set([
  'bootstrap',
  'accountStats',
  'figureSparks',
  'balanceForecast',
  'alerts'
])

const persistOptions = (queryClient: QueryClient) => ({
  queryClient,
  persister: createAsyncStoragePersister({
    storage: window.sessionStorage,
    key: 'nocfo.dashboard.queries',
    retry: removeOldestQuery
  }),
  dehydrateOptions: {
    shouldDehydrateQuery: query => {
      if (query.state.status !== 'success') return false
      const key = query.queryKey
      if (key[1] === 'date_ranges' && key.length === 2) return true
      return (
        key[0] === 'dashboard' &&
        typeof key[2] === 'string' &&
        PERSISTED_DASHBOARD_QUERY_KINDS.has(key[2])
      )
    },
    shouldDehydrateMutation: () => false
  }
})

export const restoreAndSubscribeDashboardPersistence = async (queryClient: QueryClient) => {
  const options = persistOptions(queryClient) as unknown as Parameters<
    typeof persistQueryClientRestore
  >[0]
  try {
    await persistQueryClientRestore(options)
  } finally {
    persistQueryClientSubscribe(options)
  }
}
